<template>
  <div>
    <record-info
      class="mb-100"
      :record="record"
      :status="status"
      is-large
    ></record-info>

    <record-status-selector
      class="mb-100"
      :record="record"
    ></record-status-selector>

    <record-property-detail-summary
      class="mb-200"
      :property="record.property"
    ></record-property-detail-summary>

    <div class="mb-100">
      <p class="stat--label">Purchase Price</p>
      <p class="stat--amount">{{ latestOfferAmount }}</p>
    </div>

    <div class="mb-100">
      <p class="stat--label">Projected Profit</p>
      <p class="stat--amount">{{ projectedProfitAmount }}</p>
    </div>

    <div class="mb-100">
      <p class="stat--label">Sale Amount</p>
      <p class="stat--amount">{{ saleAmount }}</p>
    </div>

    <div>
      <p class="stat--label">Actual Profit</p>
      <p class="stat--amount">{{ actualProfitAmount }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeadBoxCompleted",
  props: {
    record: {
      type: Object,
      required: true
    },
    status: {
      type: Object,
      required: true
    }
  },
  computed: {
    latestOfferAmount() {
      if(this.record.latest_offer) return this.convertAmountToCurrency(this.record.latest_offer.amount);

      return '--';
    },
    projectedProfitAmount() {
      return this.convertAmountToCurrency(this.record.projected_profit);
    },
    saleAmount() {
      return this.convertAmountToCurrency(this.record.selling_info.sale_amount);
    },
    actualProfitAmount() {
      return this.convertAmountToCurrency(this.record.actual_profit);
    }
  },
  methods: {
    convertAmountToCurrency(amount) {
      if (!amount) return "--";
      return this.$utils.formatCurrency(amount);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.stat {

  &--label {
    font-size: 0.75rem;
    color: $text-muted;
  }

  &--amount {
    margin-top: 4px;
    font-size: 1.125rem;
  }

  &--subtitle {
    margin-top: 4px;
    font-size: 0.625rem;
    color: $text-muted;
  }
}
</style>
